import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type Props = {
  summary: string;
  isLoading: boolean;
};

export const SummaryBody = ({ summary, isLoading }: Props) => {
  const bodyRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when summary changes (during streaming)
  useEffect(() => {
    if (bodyRef.current && summary) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [summary]);

  return (
    <div className="summary_modal_body" ref={bodyRef}>
      {isLoading ? (
        <div>Nalagam povzetek...</div>
      ) : (
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{summary}</ReactMarkdown>
      )}
    </div>
  );
};
